import { render, staticRenderFns } from "./countBadge.vue?vue&type=template&id=fccbe468"
import script from "./countBadge.vue?vue&type=script&lang=js"
export * from "./countBadge.vue?vue&type=script&lang=js"
import style0 from "./countBadge.vue?vue&type=style&index=0&id=fccbe468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports